import { createSelector } from '@reduxjs/toolkit';

import { getLoggedInUsersOrganizationMaterialSet } from './getLoggedInUsersOrganizationMaterialSetSelector';

export const getDefaultLumberListGuid = createSelector(
  getLoggedInUsersOrganizationMaterialSet,
  (materialSet) => materialSet?.defaultMaterials.lumberListGuid ?? null,
);

export const getDefaultPlateListGuid = createSelector(
  getLoggedInUsersOrganizationMaterialSet,
  (materialSet) => materialSet?.defaultMaterials.plateListGuid ?? null,
);

export const getDefaultHangerListGuid = createSelector(
  getLoggedInUsersOrganizationMaterialSet,
  (materialSet) => materialSet?.defaultMaterials.hangerListGuid ?? null,
);
